const Location = {

    // FIELDS
    "location": "Location",
    "name": "Name",
    "description": "Description",
    "block": "Block",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Location",
    "filter_title": "Location Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_block": "Block",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Location Name",
    "error_description": "Enter Description",
    "error_block": "Select Block",
    "error_status": "Select Status",

}

export default Location;

